import { useState } from "react";
import { PdfService } from "utilities/services/pdfs/pdf-service";

interface UseNfpaPdfArgs {
    name: string;
}
const useNfpaPdf = ({ name }: UseNfpaPdfArgs) => {
    const [isGenerating, setIsGenerating] = useState(false);

    const onGeneratePdf = async () => {
        const currentLocation = window.location.href;

        setIsGenerating(true);
        await PdfService.get({ url: currentLocation, name });
        setIsGenerating(false);
    };

    return {
        isGenerating,
        onGeneratePdf,
    };
};

export default useNfpaPdf;
